
const digest = '3fa177b32edce238e7ae93235f65ce2affba9281ed78d2537160a2392b2457ab';
const classes = {"wrapper":"_wrapper_1flyi_1","buttonsWrapper":"_buttonsWrapper_1flyi_8","button":"_button_1flyi_8"};
const css = `._wrapper_1flyi_1 {
  width: 100%;
  height: 40px;
  flex-shrink: 0;
  padding: 12px 0;
}

._buttonsWrapper_1flyi_8 {
  display: flex;
  justify-content: center;
  gap: 15px;
}

._button_1flyi_8 {
  background: white;
  border-radius: 5px;
  padding: 0 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  